import { Link } from 'react-router-dom';

const footerLinks = {
  shop: {
    title: '精品分类',
    links: [
      { label: '身体护理', path: '/category' },
      { label: '情趣配饰', path: '/category' },
      { label: '互动游戏', path: '/category' },
      { label: '智能设备', path: '/category' },
    ],
  },
  guide: {
    title: '选购指南',
    links: [
      { label: '新手入门', path: '/articles' },
      { label: '选购技巧', path: '/articles' },
      { label: '产品评测', path: '/articles' },
      { label: '使用养护', path: '/articles' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '品质承诺', path: '/about' },
      { label: '隐私保障', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
  support: {
    title: '客户服务',
    links: [
      { label: '配送说明', path: '/about' },
      { label: '退换政策', path: '/about' },
      { label: '常见问题', path: '/' },
      { label: '隐私政策', path: '/about' },
    ],
  },
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 max-w-7xl mx-auto">
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4 tracking-wide">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
          <div className="flex items-center gap-2">
            <span className="text-lg font-heading font-semibold text-background-100 tracking-wide">
              臻品阁
            </span>
            <span className="text-xs text-background-500 font-label tracking-widest uppercase">
              Premium Collection
            </span>
          </div>
          <p className="text-xs text-background-500">
            &copy; {currentYear} 臻品阁 版权所有 | 用心甄选，品质生活
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-red-packet-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}